import React from "react";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";
import { useMutation, useQuery } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";

const createTimeLogAttendance = async (input) => {
  const { data } = await http_payroll.post(
    Api_EndPoints.CreateTimeLogAttendance,
    input,
  );
  return data;
};

const getAttendanceTimeLog = async ({
  companyCode,
  locationCode,
  fromDate,
  toDate,
  employeeCode,
}) => {
  let queryString = `?companyCode=${companyCode}&FromDate=${fromDate}&ToDate=${toDate}&LocationCode=${locationCode}`;

  if (employeeCode !== 0) {
    queryString += `&EmployeeCode=${employeeCode}`;
  }

  // if (companyCode && locationCode) {
  if (companyCode) {
    const { data } = await http_payroll.get(
      `${Api_EndPoints.GetAttendanceTimeLogDetails}${queryString}`,
    );
    return data;
  }
  return [];
};

const timeLogWeelyOff = async (input) => {
  const { data } = await http_payroll.post(
    Api_EndPoints.TimeLogWeelyOffAttendance,
    input,
  );
  return data;
};

export const useCreateTimeLogAttendanceMutation = () => {
  return useMutation({
    mutationFn: createTimeLogAttendance,
  });
};

export const useGetTimeLogDetailsQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetAttendanceTimeLogDetails],
    queryFn: () => getAttendanceTimeLog(input),
    enabled: Boolean(
      input.companyCode && input.locationCode && input.fromDate && input.toDate,
    ),
    refetchOnWindowFocus: false,
  });
};

export const useTimeLogWeelyOffMutation = () => {
  return useMutation({
    mutationFn: timeLogWeelyOff,
  });
};
